import { useState, useEffect } from 'react';
import Modal from './Modal';

export default function OrientationModal({ children }) {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia('(orientation: portrait)').matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: portrait)');
    const handler = (e) => setIsPortrait(e.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
    
  }, []);

  
  return (
    <>
      {isPortrait && (
        <Modal
          title="Please rotate your device"
          content="This experience is best viewed in landscape mode."
        />
      )}
      {children}
    </>
  );
}
